<div class="flex flex-col overflow-x-hidden py-3" [ngClass]="collapsed() ? 'px-1' : 'px-3'">
  <div class="flex w-full flex-col">
    @for (row of rows; track row) {
      <div class="flex items-center rounded-xl px-3 py-2" [ngClass]="{ 'justify-center': collapsed() }">
        <div class="h-6 w-6 shrink-0 rounded-lg" [tuiSkeleton]="true"></div>
        @if (!collapsed()) {
          <div class="ml-3 h-4 flex-1 rounded-sm" [tuiSkeleton]="true"></div>
        }
      </div>
    }
  </div>
</div>
